<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="vc_code,vc_vendname,vc_turnvendname,vc_remark"
      placeholder="输入单据编号、供应商、备注进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.vc_id"
        :to="'/money/payverify/'+item.vc_id"
      >
        <div class="weui-cell__bd">
          <p>{{item.vc_custname}}</p>
          <p class="list-item-muted">{{item.vc_code}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'¥#,##0.00'">{{item.vc_amount1}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.vc_status!='已审核'}"
          >{{item.vc_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('vc_amount1')}}</em>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/money/verification/list",
      filters: [
        {
          type: "date",
          name: "vc_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              condition: "vc_kind in ('预付冲应付','应付转应付','冲预付款','冲应付款')"
            },
            {
              value: 1,
              label: "待审核",
              condition:
                "vc_kind in ('预付冲应付','应付转应付','冲预付款','冲应付款') and vc_statuscode='UNAUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition:
                "vc_kind in ('预付冲应付','应付转应付','冲预付款','冲应付款') and vc_statuscode='AUDITED'"
            }
          ]
        }
      ]
    };
  }
};
</script>